/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type CurrencySelector_viewer = {|
  +currencies: ?$ReadOnlyArray<?string>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CurrencySelector_viewer",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "currencies",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/Footer/CurrencySelector/__generated__/CurrencySelector_viewer.graphql.js